<template>
  <div class="content">
    <div class="content-header">
      <div class="content-header-box">
        <div class="header-left">
          <div class="header-icon">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTM0NjNFNUNGNjM2MTFFOEJBMDQ4QUVGQzI5NDMzN0MiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTM0NjNFNURGNjM2MTFFOEJBMDQ4QUVGQzI5NDMzN0MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxMzQ2M0U1QUY2MzYxMUU4QkEwNDhBRUZDMjk0MzM3QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxMzQ2M0U1QkY2MzYxMUU4QkEwNDhBRUZDMjk0MzM3QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpwPTVgAAAB2SURBVHjaYvr///++/5SBfUwMDAxGDJQBAxYgYQHF5IKTIENuQDHZgImBCoAqhoC8ww/EihSYcR9kyAUgVqDAkAcg7/yj0Df/QC4xAGJlCgy5BzLkM9RLwySK1YDYigIzjoMMOQrEIhQY8hbknbMU+uYkQIABAFS6UwgvbSfaAAAAAElFTkSuQmCC"
              style="height: 13px;" />
          </div>
          <div class="header-tit"><span class="tit-a">IOTDCS</span><span class="tit-b">|</span><span
              class="tit-c">视图</span></div>
        </div>
        <div class="header-right">
          <el-dropdown size="small" placement="top-end">
            <div class="hearde-right-icon-1" @click="goback"></div>
          </el-dropdown>
          <div class="hearde-right-icon-tit">基础数据管理工具</div>
          <el-dropdown size="small" placement="top-end">
            <div class="hearde-right-icon-5"></div>
            <el-dropdown-menu slot="dropdown">
              <div>
                <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                  请求远程协助
                </el-dropdown-item>
              </div>
              <div>
                <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                  支持服务平台
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="hearde-right-icon-tit">支持</div>
          <el-dropdown size="small" placement="top-end">

            <div class="hearde-right-icon-4"></div>
            <el-dropdown-menu slot="dropdown">
              <div @click="tuceng">
                <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                  图层
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>

          <div class="hearde-right-icon-tit">应用</div>

          <div class="hearde-right-icon-2"></div>
          <div class="hearde-right-icon-tit">{{ username }}</div>
          <div @click="goback" class="hearde-right-icon-3"></div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div id='map-container' />
      <div class="card-ceng" v-if="showpho">
        <div class="card-header"></div>
        <el-scrollbar class="content">
          <ul>
            <li v-for="item in layers" :key="item.index" class="layeritem">
              <div class="layer-colorBlock" :style="'background:' + item.color"></div>
              <div class="layer-text" :title="item.name">{{ item.name }}</div>
              <el-switch v-model="item.isOff" inline-prompt active-color="#777777" inactive-color="#13ce66"
                @change="doSwitchLayer"></el-switch>
            </li>
          </ul>
        </el-scrollbar>
      </div>
      <!-- <UILayer @getReply="getReply" /> -->
    </div>
    <transition name="fadeBox">
      <div class="con-dialog" v-show="diaShow">
        <div class="con-box">
          <div class="dia-box">
            <div class="box-header">
              <div class="box-header-tit" style="color: #cbcbcb;">{{ title }}</div>
              <div class="box-header-close" @click="diaShow = false" style="color: #cbcbcb;">X</div>
            </div>
            <div class="box-body">
              <!--  <el-row>
                <el-col :span="3">
                  <div style="width: 100%;"><span style="color: aliceblue;">温度：25.3℃</span></div>
                </el-col>
                <el-col :span="3">
                  <div style="width: 100%;"><span style="color: aliceblue;">湿度：15.31%</span></div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 100%;"><span style="color: aliceblue;">CO2：153.25ppm</span></div>
                </el-col>
                <el-col :span="4">
                  <div style="width: 100%;"><span style="color: aliceblue;">VOC：205.06ppm</span></div>
                </el-col>
                <el-col :span="7">
                  <div style="width: 100%;display: flex;"><span style="color: aliceblue;">温度设定：</span>
                    <input>
                  </div>
                </el-col>
              </el-row> -->
              <!-- <div style="width: 100%;display: flex;margin-top: 20px;">
                <div v-for="(item, index) in dataList" :key="index" style="margin-right: 50px;">
                  <div @click="updateData(item.id, '1')" class="k-off" v-if="item.type == 'BinaryW' && item.value == '0'">
                  </div>
                  <div @click="updateData(item.id, '0')" class="k-on" v-if="item.type == 'BinaryW' && item.value == '1'">
                  </div>
                  <div @click="updateData(item.id, '1')" class="l-off"
                    v-if="item.type == 'DigitalOutputW' && item.value == '0'"></div>
                  <div @click="updateData(item.id, '0')" class="l-on"
                    v-if="item.type == 'DigitalOutputW' && item.value == '1'"></div>
                </div>
              </div> -->
              <div class="box-body-fj">
                <div class="box-body-fj-img" :style="{ 'background-image': fjImagesrc }">
                  <div class="container">
                    <div :class="animaOne">
                      <div class="petal" style="--i:1"></div>
                      <div class="petal" style="--i:2"></div>
                      <div class="petal" style="--i:3"></div>
                      <div class="petal" style="--i:4"></div>
                      <div class="petal" style="--i:5"></div>
                      <div class="petal" style="--i:6"></div>
                      <div class="petal" style="--i:7"></div>
                      <div class="petal" style="--i:8"></div>
                    </div>
                  </div>
                  <div class="container1">
                    <div :class="animaTwo">
                      <div class="petal1" style="--i:1"></div>
                      <div class="petal1" style="--i:2"></div>
                      <div class="petal1" style="--i:3"></div>
                      <div class="petal1" style="--i:4"></div>
                      <div class="petal1" style="--i:5"></div>
                      <div class="petal1" style="--i:6"></div>
                      <div class="petal1" style="--i:7"></div>
                      <div class="petal1" style="--i:8"></div>
                    </div>
                  </div>
                  <!-- 报警提示 -->
                  <div class="police-box"></div>
                  <!-- 水箱效果 -->
                  <div class="water-box"></div>
                  <!-- 风机数据1 -->
                  <div class="content-data1">45.3<span style="font-size: 10px;">Hz</span></div>
                  <!-- 风机数据2 -->
                  <div class="content-data2">
                    <span>{{ fanData.hfTemp }}℃</span><br>
                    <span>{{ fanData.hfHumd }}%Rh</span>
                  </div>
                  <!-- 风机数据3 -->
                  <div class="content-data3">
                    <span>{{ fanData.xfTemp }}℃</span><br>
                    <span>{{ fanData.xfHumd }}%Rh</span>
                  </div>
                  <!-- 风机数据4 -->
                  <div class="content-data4">
                    <span>{{ fanData.sfTemp }}℃</span><br>
                    <span>{{ fanData.sfHumd }}%Rh</span>
                  </div>
                  <!-- 风机数据5 -->
                  <div class="content-data5">
                    <span>45.3Hz</span>
                  </div>
                  <!-- 风机数据5 -->
                  <div class="content-data6">
                    <span>50%</span>
                  </div>
                  <!-- 风机开关 -->
                  <div @click="switchSet" class="content-switch" :style="{ 'background-image': switchImgSrc }">

                  </div>
                  <div class="switch-tit">
                    <span>机组启停</span>

                  </div>
                  <!-- 空气流动效果1 -->
                  <div class="air-box2"></div>
                  <!-- 空气流动效果2 -->
                  <div class="air-box3"></div>
                  <!-- 饼状图 -->
                  <div class="pie-box">
                    <div style="width: 100%;height: 100%;" ref="pie"></div>
                  </div>
                  <!-- 柱状图1 -->
                  <div class="bar-box1">
                    <!-- 阀门角度 -->
                    <div class="bar-box1-fa1" :style="{ 'transform': transformBar1 }">
                    </div>
                    <div class="bar-box1-fa2 flex" :style="{ 'transform': transformBar1 }">
                    </div>
                    <div class="bar-box1-fa3 flex" :style="{ 'transform': transformBar1 }">
                    </div>
                  </div>

                  <!-- 柱状图2 -->
                  <div class="bar-box2">
                    <!-- 阀门角度 -->
                    <div class="bar-box1-fa1" :style="{ 'transform': transformBar1 }">
                    </div>
                    <div class="bar-box1-fa2 flex" :style="{ 'transform': transformBar1 }">
                    </div>
                    <div class="bar-box1-fa3 flex" :style="{ 'transform': transformBar1 }">
                    </div>
                  </div>
                  <!-- 柱状图3 -->
                  <div class="bar-box3">
                    <div class="bar-box1-fa1" :style="{ 'transform': transformBar2 }">
                    </div>
                    <div class="bar-box1-fa2 flex" :style="{ 'transform': transformBar2 }">
                    </div>
                    <div class="bar-box1-fa3 flex" :style="{ 'transform': transformBar2 }">
                    </div>
                  </div>
                  <!-- 柱状图4 -->
                  <div class="bar-box4">
                    <div style="width: 100%;height: 100%;" ref="bar4"></div>
                  </div>

                  <!-- 蒙版深度 -->
                  <div class="mask-box"></div>
                  <!-- 温度设定 -->
                  <div class="temp-box">
                    <div
                      style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;flex-wrap: wrap;">
                      <div style="width: 100%;font-size: 10px;color: #bebebe;">参数设置</div>
                      <div class="flex" style="width: 100%;justify-content: flex-start;;padding-top: 0;">
                        <input style="width: 40%;background-color: transparent" /><span
                          style="color: #bebebe;margin-left: 5px;font-size: 10px;">℃</span>
                      </div>
                      <div class="flex" style="width: 100%;justify-content: flex-start;;padding-top: 0;">
                        <input style="width: 40%;background-color: transparent;padding-top: 0;" />
                        <span style="color: #bebebe;margin-left: 5px;font-size: 10px;">%Rh</span>
                      </div>
                      <div class="flex" style="width: 100%;justify-content: flex-start;;padding-top: 0;">
                        <input style="width: 40%;background-color: transparent;padding-top: 0;" />
                        <span style="color: #bebebe;margin-left: 5px;font-size: 10px;">Hz</span>
                      </div>
                    </div>
                  </div>
                  <!-- 新风量 -->
                  <div class="temp-box" style="height: 40px;top: 160px;left: 80px;">
                    <div
                      style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;flex-wrap: wrap;">
                      <div style="width: 100%;font-size: 10px;color: #bebebe;">新风量</div>
                      <div class="flex" style="width: 100%;justify-content: flex-start;">
                        <input style="width: 25%;background-color: transparent;" v-model="freshAirData"
                          @change="updateFreshData" />
                        <span style="color: #bebebe;margin-left: 5px;font-size: 10px;">%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <fanone :dialogoneshow="dialogoneshow" @dialogOneClose="dialogOneClose"></fanone>
    <fantwo :dialogtwoshow="dialogtwoshow" @dialogTwoClose="dialogTwoClose"></fantwo>
    <fanthree :dialogthreeshow="dialogthreeshow" @dialogThreeClose="dialogThreeClose"></fanthree>
  </div>
</template>

<script>
import echarts from 'echarts';
import service from '../../service/leftService.js';
import Vue from 'vue';
import vjmap from 'vjmap';
import ToolTip from "@/components/vjmapUtil/ToolTip";
import UILayer from '@/components/vjmapUtil/UILayer';
import 'vjmap/dist/vjmap.min.css';
import fanone from '@/components/graphically/dialog/fanone'
import fantwo from '@/components/graphically/dialog/fantwo'
import fanthree from '@/components/graphically/dialog/fanthree'
export default {
  name: '',
  props: [''],
  data() {
    return {
      fanData: {
        hfTemp: '22.5',
        hfHumd: '30.2',
        xfTemp: '22.5',
        xfHumd: '30.2',
        sfTemp: '22.5',
        sfHumd: '30.2',
        pfTemp: '22.5',
        pfHumd: '30.2',
        bwon: '1', // 开关
        awspt: '22.5', // 温度设定
        ratio: '30', // 风阀开度
        fkTemp: "22.5" //反馈温度
      },
      dialogoneshow: false,
      dialogtwoshow: false,
      dialogthreeshow: false,
      map: null,
      username: localStorage.getItem("username"),
      diaShow: false,
      dataList: [],
      interfaceName: '',
      cadId: 'ceda4e7d3895',
      layers: null,
      showpho: false,
      title: '',
      switchImgSrc: 'url(../../../static/img/tencent/off.png)',
      fjImagesrc: 'url(../../../static/img/lengdongzhan/012off.png)',
      animaOne: 'loader',
      animaTwo: 'loader1',
      freshAirData: '30',
      pieData: '30',
      bar1Data: '30',
      bar2Data: '30',
      bar3Data: '60',
      transformBar1: 'rotate(0deg)',
      transformBar2: 'rotate(90deg)',
      pointArr: [{ "x": 3156554.34, y: 129160.016, z: undefined }, { x: 3153041.49, y: 120816.942, z: undefined }, { x: 3167784.16, y: 120919.343, z: undefined }, { x: 3172257.5, y: 115445.205, z: undefined }, { x: 3166852.53, y: 74007.1163, z: undefined }, { x: 3169492.14, y: 74181.519, z: undefined }, { x: 3179462.24, y: 69364.1956, z: undefined }, { x: 3102245.8, y: 63493.7596, z: undefined }, { x: 3078008.19, y: 139849.388, z: undefined }, { x: 3159538.05, y: 134397.166, z: undefined }, { x: 3078264.18, y: 90791.7181, z: undefined }, { x: 3129496.59, y: 74162.1803, z: undefined }, { x: 3174460.63, y: 124792.718, z: undefined }, { x: 3135680.47, y: 95943.0124, z: undefined }, { x: 3087460.98, y: 55053.1302, z: undefined }, { x: 3147725.95, y: 137527.507, z: undefined }]
    };
  },

  components: {
    ToolTip,
    UILayer,
    fanone,
    fantwo,
    fanthree
  },

  computed: {},

  beforeMount() { },

  mounted() {
    this.$nextTick(function () {
      this.echartsDrawLine();
    });
    this.initMap();
  },
  provide() {
    return {
      getMap: () => this.map,
    };
  },
  methods: {
    tuceng() {
      this.showpho = !this.showpho
    },
    // 获取到所有图层
    getVisibleLayer() {
      return this.layers.reduce((sum, val) => {
        if (!val.isOff) {
          sum.push(val.name)
        }
        return sum;
      }, [])
    },
    doSwitchLayer() {
      this.map.switchLayers(this.map.getService(), this.getVisibleLayer())
    },

    cad1() {
      this.cadId = "ceda4e7d3895"
      this.initMap()
    },
    getReply(param) {
      if (param) {
        this.title = param
        this.interfaceName = param
        //this.getData(param)
        if (param == "F1ICU14控制数据接口") {
          this.diaShow = true
          this.getData('F4KHA2空调机组参数数据接口')
        } else if (param == "F1ICU20控制数据接口") {
          this.dialogoneshow = true
        } else if (param == "F1ICU17控制数据接口") {
          this.dialogtwoshow = true
        } else if (param == "F1ICU4控制数据接口") {
          this.dialogthreeshow = true
        } else {
          this.diaShow = true
        }

      } else {
        this.diaShow = false
      }
    },
    switchBtn() {
      this.showLine = !this.showLine
    },
    // 南北向红绿灯数据
    getPublicData() {

    },

    // 返回上一页
    goback() {
      this.$router.go(-1)
    },
    // 生成地图点位
    async initMap() {
      const env = {
        serviceUrl: "http://222.128.47.96:27660/api/v1",
        accessToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6MSwiVXNlcm5hbWUiOiJyb290MSIsIk5pY2tOYW1lIjoicm9vdDEiLCJBdXRob3JpdHlJZCI6InJvb3QiLCJCdWZmZXJUaW1lIjo4NjQwMCwiZXhwIjo0ODQwOTI1ODYxLCJpc3MiOiJ2am1hcCIsIm5iZiI6MTY4NzMyNDg2MX0.0P4hQkpOp1h7ynqjA3gMbckkG5b4PWtHSNGnWmfmJl4",
        exampleMapId: "sys_zp"
      };
      // 地图服务对象
      let svc = new vjmap.Service(env.serviceUrl, env.accessToken)
      // 打开地图
      let res = await svc.openMap({
        mapid: this.cadId, // 地图ID
        mapopenway: vjmap.MapOpenWay.GeomRender, // 以几何数据渲染方式打开
        style: vjmap.openMapDarkStyle() // div为深色背景颜色时，这里也传深色背景样式
      })
      if (res.error) {
        // 如果打开出错
        console.error(res.error)
        return;
      }
      // 获取地图范围
      let mapExtent = vjmap.GeoBounds.fromString(res.bounds);
      // 根据地图范围建立几何投影坐标系
      let prj = new vjmap.GeoProjection(mapExtent);

      // 地图对象
      let map = new vjmap.Map({
        container: "map-container", // DIV容器ID
        style: svc.vectorStyle(), // 样式，这里是栅格样式
        center: prj.toLngLat(mapExtent.center()), // 设置地图中心点
        zoom: 2.8,
        maxZoom: 5, // 设置地图缩放级别,
        minZoom: 2.8,
        pitch: 40, // 倾斜角度
        renderWorldCopies: false, // 不显示多屏地图
        pitchWithRotate: false,
        dragRotate: false // 拖动旋转
      });
      this.map = map;
      // 关联服务对象和投影对象
      map.attach(svc, prj);
      // 根据地图本身范围缩放地图至全图显示
      map.fitMapBounds();
      await map.onLoad(); // 等待地图加载完成
      map.setRasterOpacity(svc.rasterLayerId(), 0.5);

      // this.showUI()
      // 获取所有图层
      this.layers = svc.getMapLayers();
      /* if (typeof vjThree !== "object") {
        // 如果没有环境
        await vjmap.addScript([{
          src: "../../utils/vjThree.min.js"
        }, {
          src: "../../utils/vjthree.min.css"
        }])
      } */

      /* const threeContext = map.createThreeJsContext({
        defaultLights: true,
        enableSelectingObjects: false
      });
      map.addLayer(new vjmap.ThreeLayer({ context: threeContext }));

      let flylines = []
      const addflylines = () => {
        if (flylines.length > 0) return;
        for (let i = 0; i < this.pointArr.length; i++) {
          debugger
          let pt = this.pointArr[i];
          let pt2 = mapExtent.randomPoint();
          let mesh = threeContext.flyline({
            source: {   // 线的起点
              x: pt.x,
              y: pt.y,
              z: 0
            },
            target: {  // 线的终点
              x: pt.x,
              y: pt.y,
              z: 80000,
            },
            count: 1000,
            range: 500,
            height: 100,
            color: vjmap.randomColor(),
            color2: vjmap.randomColor(),
            speed: 10,
            size: 5,
            opacity: 1.0,
          });
          flylines.push(mesh)
        }

      }
      addflylines();



      const removeflylines = () => {
        if (flylines.length == 0) return;
        for (let c of flylines) {
          c.stop();
          threeContext.remove(c)
        }
        flylines = []
      }


      const threeContext1 = map.createThreeJsContext({
        defaultLights: true,
        enableSelectingObjects: false
      });
      map.addLayer(new vjmap.ThreeLayer({ context: threeContext1 }));

      let radialGradients = []
      const addRadialGradients = () => {
        if (radialGradients.length > 0) return;
        for (let i = 0; i < this.pointArr.length; i++) {
          let pt = this.pointArr[i];
          let mesh = threeContext1.radialGradient(pt, {
            size: 3000,
            speed: 0.03,
            color: new THREE.Vector3(Math.random(), Math.random(), Math.random())
          });
          radialGradients.push(mesh)
        }
      }
      addRadialGradients();



      const removeRadialGradients = () => {
        if (radialGradients.length == 0) return;
        for (let c of radialGradients) {
          c.stop();
          threeContext1.remove(c)
        }
        radialGradients = []
      } */







      let geoDatas = [];
      /* for(let i = 1;  i <= 5; i++) {debugger
          let mapBounds = map.getGeoBounds(i / 20.0);
          let points = mapBounds.toPointArray();
          points.push(points[0]); // 闭合
          geoDatas.push({
              points: map.toLngLat(points),
             // id: i,
              properties: {
                  lineWidth: 4 + i * 2,
                  name: `${i}环`
              }
          });
      } */
      /* let points = [
        [407572.69952,29472.71492],
        [407572.69952,12122.12323],
        [388145.57425,11937.54247],
        [388099.42906, 2662.35915]
      ]
      geoDatas.push({
        points: map.toLngLat(points),
        properties: {
            lineWidth: 4 + 1 * 2,
            //name: `${i}环`
        }
      })
  

const loadUrlImage = (src) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = src;
        image.onload = () => {
            resolve(image)
        }
        image.onerror = ()=> {
            reject(`load image ${src} error`)
        }
    })
}
      let img = await loadUrlImage("../../../static/img/guanghuan/title-bg.png");

      let createImagesOptions = {
    // canvasWidth: img.width,
    // canvasHeight: img.height * 3,
    // frameCount: 4,
     directionReverse: true,
    // fillColor: "#989898",
    draw: (context, width, height, opts) => {
        // 绘制图片回调，只需绘制第一帧的内容 context为canvas上下文，width,height为图片宽高，opts为上面传入的选项值
        // 填充背景色
        if (opts.fillColor) {
            context.fillStyle = opts.fillColor;
            context.fillRect(0, 0, width, height );
        }
        // 图片居中显示
        context.drawImage(img, 0, 0, img.width, img.height, 0, height / 2.0 - img.height / 2.0, width, img.height)
    }
      };

      let animateImages = vjmap.createAnimateImages(createImagesOptions);
let animateLine = vjmap.createAnimateLineLayer(map, geoDatas, {
    animateImages,
    lineWidth: ['get', 'lineWidth'],
    lineOpacity: ['case', ['to-boolean', ['feature-state', 'hover']], 0.6, 1.0],
    isHoverPointer: true,
    isHoverFeatureState: true,
    speed: 1,
}); */


      // 实体类型ID和名称映射
      const { entTypeIdMap } = await svc.getConstData();
      const mapBounds = this.map.getGeoBounds(0.6);
    },
    // 获取数据接口信息
    getData(val) {
      let _this = this
      let obj = {
        args: [val]
      }
      service.getPublicData2(obj).then(res => {
        _this.dataList = [...res]
        _this.fanModelOne(res)
      }).catch(err => {
        console.log(err)
      })
    },
    // 修改数据接口
    updateData(id, val) {
      let _this = this
      let obj = {
        "id": id,
        "value": val
      }
      service.updatePhysicalPoint(obj).then(res => {
        this.$Message.success("修改成功")
        _this.getData(_this.interfaceName)
      }).catch(err => {
        this.$Message.error("修改失败")
      })
    },
    //饼状图加载
    echartsDrawLine() {
      let pieOne = echarts.init(this.$refs.pie);
      pieOne.setOption(
        {
          tooltip: {
            show: false,
            trigger: 'item'
          },
          color: ['#909090', '#cd9078'],
          grid: {
            left: '0%',
            right: '0%',
            top: '0%',
            bottom: '0%',
          },
          legend: {
            show: false,
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: 'Access From',
              type: 'pie',
              radius: '35%',
              data: [
                { value: this.bar3Data, name: 'Search Engine' },
                { value: this.pieData, name: 'Direct' },
              ],
              label: {
                normal: {
                  show: false
                },
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              emphasis: {
                itemStyle: {
                  show: false,
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne.resize()
      })

      let bar4 = echarts.init(this.$refs.bar4);
      bar4.setOption(
        {
          color: ['#c26a3b73'],
          grid: {
            left: '0%',
            right: '15%',
            top: '0%',
            bottom: '25%',
          },
          xAxis: {
            show: false,
            type: 'category',
            data: ['Mon']
          },
          yAxis: {
            show: false,
            type: 'value',
            min: 0,
            max: 100,
          },
          series: [
            {
              data: [50],
              type: 'bar',
              barWidth: '35%',
              showBackground: true,
              backgroundStyle: {
                color: '#2b2b2b6b'
              },
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        bar4.resize()
      })
    },
    // 模板1风机的开关
    switchSet() {
      if (this.switchImgSrc == 'url(../../../static/img/tencent/on.png)') {
        this.switchImgSrc = 'url(../../../static/img/tencent/off.png)'
        this.fjImagesrc = 'url(../../../static/img/lengdongzhan/012off.png)'
        this.animaOne = 'loader'
        this.animaTwo = 'loader1'
      } else {

        this.$confirm('确认开启风机吗?, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '开启成功!'
          });
          this.switchImgSrc = 'url(../../../static/img/tencent/on.png)'
          this.fjImagesrc = 'url(../../../static/img/lengdongzhan/012.gif)'
          this.animaOne = 'loaderOn'
          this.animaTwo = 'loader1On'
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消开启'
          });
        });

      }

    },
    // 改变新风量的值
    updateFreshData() {
      this.pieData = this.freshAirData
      this.bar1Data = this.freshAirData
      this.bar2Data = this.freshAirData
      this.bar3Data = 90 - this.freshAirData
      this.transformBar1 = `rotate(${this.freshAirData}deg)`
      this.transformBar2 = `rotate(${this.bar3Data}deg)`
      this.echartsDrawLine()
    },
    // 模板1关闭
    dialogOneClose(val) {
      this.dialogoneshow = val
    },
    // 模板2关闭
    dialogTwoClose(val) {
      this.dialogtwoshow = val
    },
    // 模板3关闭
    dialogThreeClose(val) {
      this.dialogthreeshow = val
    },
    fanModelOne(val) {
      val.forEach((item, index) => {
        if (item.attribute.device_name == 'DEV_AIO0') {
          if (item.name == 'AIR_Temp') { // 新风温度
            this.fanData.xfTemp = item.value
          }
          if (item.name == 'AIR_Humd') { // 新风湿度
            this.fanData.xfHumd = item.value
          }
        }
        if (item.attribute.device_name == 'DEV_AIO1') {
          if (item.name == 'AIR_Temp') { // 回风温度
            this.fanData.hfTemp = item.value
          }
          if (item.name == 'AIR_Humd') { // 回风湿度
            this.fanData.hfHumd = item.value
          }
          if (item.name == 'AIR_AI1') { // 送风湿度
            this.fanData.sfHumd = item.value
          }
          if (item.name == 'AIR_AI2') { // 送风湿度
            this.fanData.sfHumd = item.value
          }
        }
        if (item.attribute.device_name == 'ACUCMD') {
          if (item.name == 'IW_AIR_RATIO') { // 新风温度
            this.freshAirData = item.value
            this.updateFreshData()
          }
        }
      })
    }
  },
  destroyed() {
    if (this.map) {
      this.map.remove();
    }
  },
  beforeDestroy() {

  },
  watch: {

  }
}

</script>
<style  scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

input {
  height: 20px;
  font-size: 10px;
  color: #dbdbaa;
  border: 1px solid #464646;
}

input:focus {
  outline: none;
  border: 2px solid #6f6f6f;
}

.content {
  width: 100%;
  height: 100%;
  background-color: #3e3e3e;
  position: relative;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
}

.content-header {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 40px;
  background-color: #525659;
  border-bottom: 1px solid rgb(37, 37, 37);
}

.content-body {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 40px;
}

.content-body-box {
  width: 100%;
  height: 100%;
  display: flex;
}

.content-body-menu {
  width: 200px;
  height: 100%;
  background-color: #525659d2;
  overflow: hidden;
}

.content-body-box-main {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}

.content-box-main-solar {
  width: 1700px;
  height: 900px;
  position: relative;
  background-image: url('../../../static/img/lengdongzhan/back3.png');
}

.menu-box {
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #2f3030;
  color: #fff;
}

.menu-box:hover {
  background-color: #2f3030;
  cursor: pointer;
}

.icon {
  width: 19px;
  height: 56px;
  background-size: 100% 100%;
  position: absolute;
}

.go {
  width: 60px;
  height: 25px;
  background-size: 100% 100%;
  position: absolute;
}

.content-header-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-left: 15px;
  padding-right: 15px;
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.header-left {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-icon {
  margin-right: 30px;
  margin-top: 4px;
}

.header-tit {
  color: #fff;
  font-size: 15px;
  font-weight: 700;
}

.tit-a {
  margin-right: 5px;
}

.tit-b {
  margin-right: 5px;
  font-size: 18px;
}

.header-right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.hearde-right-icon-1 {
  width: 26px;
  height: 26px;
  background-image: url('../../assets/gong.png');
  background-size: 100% 100%;
  margin-right: 8px;
  cursor: pointer;
}

.hearde-right-icon-tit {
  color: #fff;
  font-size: 13px;
  margin-right: 20px;
}

.hearde-right-icon-2 {
  width: 21px;
  height: 21px;
  background-image: url('../../assets/user.png');
  background-size: 100% 100%;
  margin-right: 10px;
  cursor: pointer;
}

.hearde-right-icon-4 {
  width: 21px;
  height: 21px;
  background-image: url('../../assets/服务.png');
  background-size: 100% 100%;
  margin-right: 10px;
  cursor: pointer;
}

.hearde-right-icon-5 {
  width: 21px;
  height: 21px;
  background-image: url('../../assets/服务中心.png');
  background-size: 100% 100%;
  margin-right: 10px;
  cursor: pointer;
}

.hearde-right-icon-3 {
  width: 20px;
  height: 20px;
  background-image: url('../../assets/退出.png');
  background-size: 100% 100%;
  margin-right: 10px;
  cursor: pointer;
}

.con {
  width: 624px;
  height: 624px;
  background-image: url('../../../static/img/lengdongzhan/center.png');
  position: relative;
  overflow: hidden;
}

#map-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2b2b2b;
}

.card-ceng {
  position: absolute;
  background-color: #ffffff;
  z-index: 1;
  width: 15%;
  height: 95%;
  top: 40px;
  right: 0;
}

.card-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.con-dialog {
  position: relative;
  z-index: 5;
  width: 100%;
  height: 100%;
}

.con-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dia-box {
  width: 700px;
  height: 400px;
  background-color: #060606;
  border: 1px solid #5f5f5f;
}

.box-header {
  width: 100%;
  height: 25px;
  background-color: #525659;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  box-sizing: border-box;
  padding: 0px 5px 0px 20px;
}

.box-header-close {
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  cursor: pointer;
}

.box-body {
  width: 100%;
  height: 90%;
  box-sizing: border-box;
  flex-wrap: wrap;
}

.box-body-fj {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-body-fj-img {
  width: 724px;
  height: 373px;

  position: relative;
}

.k-off {
  width: 30px;
  height: 30px;
  background-image: url('../../../static/img/lengdongzhan/koff.png');
  background-size: 100% 100%;
  cursor: pointer;
}

.k-on {
  width: 30px;
  height: 30px;
  background-image: url('../../../static/img/lengdongzhan/kon.png');
  background-size: 100% 100%;
  cursor: pointer;
}

.l-off {
  width: 30px;
  height: 30px;
  background-image: url('../../../static/img/lengdongzhan/doff.png');
  background-size: 100% 100%;
  cursor: pointer;
}

.l-on {
  width: 30px;
  height: 30px;
  background-image: url('../../../static/img/lengdongzhan/don.png');
  background-size: 100% 100%;
  cursor: pointer;
}

ul li {
  height: 40px;
  line-height: 40px;
  display: flex;
  align-items: center;
  position: relative;
  border-bottom: 1px solid #989898;

}

ul li .layer-colorBlock {
  border: 1px solid #989898;
  display: inline-block;
  width: 16px;
  height: 40px;
}

.layer-text {
  color: #fff;
}

.container {
  position: absolute;
  width: 5vh;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animate_container 2s linear 1 forwards;
  left: 442px;
  top: 248px;
}

.container1 {
  position: absolute;
  width: 5vh;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animate_container 2s linear 1 forwards;
  left: 309px;
  top: 80px;
}

.police-box {
  position: absolute;
  width: 20px;
  height: 72px;
  top: 234px;
  left: 317px;
  background-color: #ff00003e;
  animation: fade-data-v-582296d4 .6s infinite;
  -webkit-animation: fade-data-v-582296d4 .6s infinite;
  z-index: 10;
}

.water-box {
  position: absolute;
  width: 10px;
  height: 73px;
  top: 235px;
  left: 400px;
  background-color: #009dff45;
  animation: fade-data-v-582296d4 .6s infinite;
  -webkit-animation: fade-data-v-582296d4 .6s infinite;
  z-index: 10;
}

.pie-box {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 133px;
  left: 121px;
  z-index: 10;
}

.bar-box1 {
  position: absolute;
  width: 5px;
  height: 83px;
  top: 229px;
  left: 168px;
  z-index: 10;
}

.bar-box1-fa1 {
  position: absolute;
  width: 10px;
  height: 26px;
  top: 0;
  left: -2px;
  z-index: 10;
  background-image: url(../../../static/img/lengdongzhan/fa.png);
  background-size: 100% 100%;
}

.bar-box1-fa2 {
  position: absolute;
  width: 10px;
  height: 25px;
  top: 28px;
  left: -2px;
  z-index: 10;
  background-image: url(../../../static/img/lengdongzhan/fa.png);
  background-size: 100% 100%;
}

.bar-box1-fa3 {
  position: absolute;
  width: 10px;
  height: 25px;
  top: 56px;
  left: -2px;
  z-index: 10;
  background-image: url(../../../static/img/lengdongzhan/fa.png);
  background-size: 100% 100%;
}

.bar-box2 {
  position: absolute;
  width: 11px;
  height: 70px;
  top: 60px;
  left: 168px;
  z-index: 10;
}

.bar-box3 {
  position: absolute;
  width: 11px;
  height: 70px;
  top: 150px;
  left: 263px;
  z-index: 10;
  transform: rotate(90deg);
}

.bar-box4 {
  position: absolute;
  width: 11px;
  height: 70px;
  top: 233px;
  left: 331px;
  z-index: 10;
}

.mask-box {
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 97%;
  top: 8px;
  background-color: #0000009f;
  z-index: 9;
}

.temp-box {
  position: absolute;
  z-index: 99;
  width: 100px;
  top: 57px;
  left: 530px;
}

.air-box1 {
  position: absolute;
  width: 100%;
  height: 100px;
  top: 40px;
  left: 0px;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(219, 238, 249, 0.034) 0) repeat-x;
  background-size: 500px 10px, 500px 10px, 10px 500px, 10px 500px;
  background-position: 0 0, 100% 0, 0 0, 0 100%;
  animation: move2 0.3s infinite linear;
}

.air-box2 {
  position: absolute;
  width: 50px;
  height: 4px;
  top: 225px;
  left: 336px;
  transform: rotate(90deg);
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(178, 178, 178, 0.84) 0) repeat-x;
  background-size: 500px 8px, 500px 8px, 8px 500px, 8px 500px;
  background-position: 0 0, 100% 0, 0 0, 0 100%;
  animation: move2 0.3s infinite linear;
}

.air-box3 {
  position: absolute;
  width: 106px;
  height: 4px;
  top: 253px;
  left: 332px;
  transform: rotate(270deg);
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(178, 178, 178, 0.84) 0) repeat-x;
  background-size: 500px 8px, 500px 8px, 8px 500px, 8px 500px;
  background-position: 0 0, 100% 0, 0 0, 0 100%;
  animation: move2 0.3s infinite linear;
}

@keyframes move2 {
  from {}

  to {
    background-position: 0 -12px, 100% 12px, 12px 0, -12px 100%;
  }
}

@keyframes animate_container {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fade {
  from {
    opacity: 1.0;
  }

  50% {
    opacity: 0.4;
  }

  to {
    opacity: 1.0;
  }
}

@-webkit-keyframes fade {
  from {
    opacity: 1.0;
  }

  50% {
    opacity: 0.4;
  }

  to {
    opacity: 1.0;
  }

}

.content-data1 {
  position: absolute;
  color: #cd9078;
  top: 94px;
  left: 311px;
  z-index: 10;
}

.content-data2 {
  position: absolute;
  color: #b4cda7;
  top: 83px;
  left: 400px;
  z-index: 10;
}

.content-data3 {
  position: absolute;
  color: #b4cda7;
  top: 249px;
  left: 50px;
  z-index: 10;
}

.content-data4 {
  position: absolute;
  color: #b4cda7;
  top: 252px;
  left: 539px;
  z-index: 10;
}

.switch-tit {
  position: absolute;
  color: #bebebe;
  top: 189px;
  left: 529px;
  z-index: 10;
  font-size: 10px;
}

.content-data5 {
  position: absolute;
  color: #cd9078;
  top: 262px;
  left: 443px;
  z-index: 10;
}

.content-data6 {
  position: absolute;
  color: #b4cda7;
  top: 170px;
  left: 358px;
  z-index: 10;
}

.content-switch {
  position: absolute;
  top: 160px;
  left: 540px;
  z-index: 10;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background-size: 100% 100%;
}

.loader {
  position: absolute;
  width: 5vh;
  height: 5vh;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* animation: animate_loader 1s linear infinite; */
  animation: none;
}

.loaderOn {
  position: absolute;
  width: 5vh;
  height: 5vh;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animate_loader 1s linear infinite;
}

.loader1 {
  position: absolute;
  width: 5vh;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* animation: animate_loader1 1s linear infinite; */
  animation: none;
}

.loader1On {
  position: absolute;
  width: 5vh;
  height: 5vh;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: animate_loader1 1s linear infinite;
}


@keyframes animate_loader {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes animate_loader1 {
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

.petal {
  position: absolute;
  width: 40%;
  height: 20%;
  /* background-color: blueviolet; */
  border: .5vh solid #cbcbcb;
  box-shadow: 0 0 10vh #cbcbcb;
  border-radius: 0 10vh 0 10vh;
  transform: rotate(calc(var(--i) * 45deg)) translateY(2.5vh);
  animation: animate_petal 1.6s linear infinite;
  animation-delay: calc(var(--i) * 200ms);
}

.petal1 {
  position: absolute;
  width: 40%;
  height: 20%;
  /* background-color: blueviolet; */
  border: .5vh solid #cbcbcb;
  box-shadow: 0 0 10vh #cbcbcb;
  border-radius: 10vh 0 10vh;
  transform: rotate(calc(var(--i) * 45deg)) translateY(2.5vh);
  animation: animate_petal 1.6s linear infinite;
  animation-delay: calc(var(--i) * 200ms);
  color: #575757;
}

@keyframes animate_petal {
  0% {
    border: .5vh solid #cbcbcb;
    box-shadow: 0 0 10vh #cbcbcb;
  }

  50% {
    border: .5vh solid #cbcbcb;
    box-shadow: 0 0 10vh #cbcbcb;
  }

  100% {
    border: .5vh solid #cbcbcb;
    box-shadow: 0 0 10vh #cbcbcb;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/graphically/cadShow.vue